export const en = {
  comments: 'COMMENTS:',
  eventLog: 'EVENT LOG:',
  viewComments: 'View comments',
  viewLog: 'View log',
  showMore: 'Show more'
};

export type Translations = typeof en;
